import React from "react";
import classes from "../Management.module.scss";
import styles from "./DealerPipeline.module.scss";

/**
 * A staff-only text box saved with its own button, so saving anything else on
 * the panel never clears what's typed here. "Not saved yet." shows while the
 * box differs from what's stored. The panel keeps the typed text (`value`), so
 * it can ask before closing over unsaved notes.
 *
 * Props: id, value, saved (the stored text), onChange(text), onSave(), busy,
 * placeholder, label (for screen readers), saveLabel, rows, children (shown
 * under the box)
 */
const StaffNotesBox = ({
  id, value, saved, onChange, onSave, busy, placeholder, label = "Staff notes", saveLabel = "Save notes", rows = 3, children,
}) => {
  const dirty = value !== (saved || "");
  return (
    <>
      <textarea
        id={id}
        className={classes.formInput}
        rows={rows}
        value={value}
        placeholder={placeholder || "Calls, what the dealer said, what to remember - only staff see this."}
        aria-label={label}
        onChange={(e) => onChange(e.target.value)}
      />
      <div className={styles.inlineRow}>
        <button type="button" className={styles.btn} disabled={busy || !dirty} onClick={onSave}>
          {saveLabel}
        </button>
        {dirty && <span className={styles.hint}>Not saved yet.</span>}
      </div>
      {children}
    </>
  );
};

export default StaffNotesBox;
